import React, { useEffect, useState } from "react"
import { PrivacyModal, SlantedWrapper, SVGLogo } from "../../components"
import { NavLink } from "react-router-dom"
import { RiEyeLine } from "react-icons/ri"
import { FaRegEyeSlash, FaRegFile } from "react-icons/fa"
import { IoMdCheckmarkCircle, IoMdCheckmark } from "react-icons/io"
import { PASSWORDRULES } from "../../utils/Formatter"
import { useAppCountries, getGhanaCountryOption } from "../../utils/appCountries"
import Select from "react-select"
import PrivacyRejectedModal from "../../components/modals/privacy-rejected-modal"

const gender = [
  {
    name: "Male",
    value: "male",
  },
  {
    name: "Female",
    value: "female",
  },
]

const Stepper = ({ activeStep, formType }) => {
  return (
    <div className="flex flex-row items-center justify-between w-full mb-4">
      <h1 className="font-semibold text-lg text-yellowcolor">
        {{
          0: formType === "personal" ? "Personal Information" : "Business Information",
          1: "Contact Info",
          2: "Business Information",
        }[activeStep]}
      </h1>


      <div className="flex flex-row items-center gap-2">
        <p className="text-base font-normal text-yellowcolor">
          Step {activeStep + 1} of 3
        </p>
      </div>

    </div>
  )

}

export const FormTypeSelector = ({ formType, setFormType, resetForm }) => {
  return (
    <div className="flex flex-row items-center gap-2 my-4 bg-gray-100 dark:bg-secondaryDark rounded-full p-1 transition-all duration-300 w-full">
      {
        ["personal", "business"].map((type) => (
          <button key={type}
            className={`h-12 w-full rounded-full ${formType === type ? "bg-black text-white" : "bg-transparent text-black dark:text-white"} transition-all duration-300`}
            onClick={() => {
              resetForm()
              setFormType(type)
            }}>
            <p className="capitalize text-base font-normal text-center">
              {type}
            </p>
          </button>
        ))
      }
    </div>
  )
}

export const FirstForm = ({
  handleNext,
  values,
  handleChange,
  onSubmit,
  errors,
  touched,
  handleBlur,
  activeStep,
  formType,
  setFormType,
  resetForm
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const handleNextStep = (e) => {
    e.preventDefault()
    onSubmit()
    if (
      // values?.firstname &&
      // values?.lastname &&
      // values?.dob &&
      values?.user_type &&
      values?.password &&
      values?.confirmpassword &&
      // !errors.firstname &&
      // !errors.lastname &&
      // !errors.dob &&
      !errors.user_type &&
      !errors.password &&
      !errors.confirmpassword
    ) {
      if (formType === "personal") {
        if (
          values?.firstname &&
          values?.lastname &&
          values?.dob &&
          !errors.firstname &&
          !errors.lastname &&
          !errors.dob
        ) {
          handleNext()
        }
      } else if (formType === "business") {
        if (
          values?.business_name &&
          !errors.business_name
        ) {
          handleNext()
        }
      }
    }
  }
  // For radio
  const roles = [
    {
      id: 1,
      name: "service_provider",
      showName: "Service Provider"
    },
    {
      id: 3,
      name: "processor",
      showName: "Processor"
    },
  ]

  const factorySize = [
    {
      id: 1,
      name: "small_scale",
      showName: "Small Scale"
    },
    {
      id: 2,
      name: "large_scale",
      showName: "Large Scale"
    },
  ]

  const materialsSource = [
    {
      id: 1,
      name: "own_farm",
      showName: "Own Farm"
    },
    {
      id: 2,
      name: "out_growers",
      showName: "Out Growers"
    },
    {
      id: 3,
      name: "aggregators",
      showName: "Aggregators"
    },
  ]

  return (
    <>
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2">
      {/* Left: Registration Form */}
      <div className="max-h-[calc(100vh-40px)] overflow-y-auto flex flex-col justify-start items-center px-4 lg:mt-8 md:px-0 min-h-screen">
        <div className="w-full max-w-[380px] mx-auto flex flex-col justify-start py-8 ">
          {/* Logo and Brand */}
          <div className="flex items-center justify-center mb-6">
            <span className="inline-flex items-center gap-3">
              <SVGLogo />
              <span className="text-2xl font-bold" style={{ color: '#FDBA2F' }}>FarmerKonnect</span>
            </span>
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900 mb-1 text-center dark:text-white">
            Create an account
          </h2>
          <p className="text-gray-500 text-center">Provide your details below to continue</p>
          <FormTypeSelector
            formType={formType}
            setFormType={setFormType}
            resetForm={resetForm}
          />
          <Stepper formType={formType} activeStep={activeStep} />
          <form className="flex flex-col gap-7" onSubmit={handleNextStep}>
            {formType === "personal" ? (<>
              {/* First Name */}
              <div>
                <label htmlFor="firstname" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                  First Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="firstname"
                  id="firstname"
                  value={values?.firstname?.trim()}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your first name"
                  className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                />
                {touched.firstname && errors.firstname && (
                  <div className="text-red-500 text-xs mt-1">{errors.firstname}</div>
                )}
              </div>
              {/* Last Name */}
              <div>
                <label htmlFor="lastname" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                  Last Name<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="lastname"
                  id="lastname"
                  value={values?.lastname?.trim()}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your last name"
                  className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                />
                {touched.lastname && errors.lastname && (
                  <div className="text-red-500 text-xs mt-1">{errors.lastname}</div>
                )}
              </div>
              {/* Date of Birth */}
              <div>
                <label htmlFor="dob" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                  Date Of Birth<span className="text-red-500">*</span>
                </label>
                <div className="relative auth">
                  <input
                    type="date"
                    name="dob"
                    id="dob"
                    value={values?.dob}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="MM/DD/YYYY"
                    className="w-full  bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                  />
                </div>
                {touched.dob && errors.dob && (
                  <div className="text-red-500 text-xs mt-1">{errors.dob}</div>
                )}
              </div>
            </>
            ) : (
              <>
                {/* Business Name */}
                <div>
                    <label htmlFor="business_name" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                    Business Name<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                      name="business_name"
                      id="business_name"
                      value={values?.business_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter your business name"
                      className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                  />
                  {touched.business_name && errors.business_name && (
                    <div className="text-red-500 text-xs mt-1">{errors.business_name}</div>
                  )}
                </div>
              </>
            )}

            {/* Select Role */}
            <div>
              <label className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Select Role<span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-6">
                {roles.map((role) => (
                  <label key={role.name} className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="user_type"
                      value={role.name}
                      checked={values?.user_type === role.name}
                      onChange={handleChange}
                      className="form-radio text-yellowcolor focus:ring-yellowcolor"
                    />
                    <span className="ml-2 text-gray-700 text-sm dark:text-white">{role.showName}</span>
                  </label>
                ))}
              </div>
              {touched.user_type && errors.user_type && (
                <div className="text-red-500 text-xs mt-1">{errors.user_type}</div>
              )}
            </div>

            {values?.user_type === "processor" && (
              <>
                {/* Factory Size */}
                <div>
                  <label htmlFor="factory_size" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                    Factory Size<span className="text-red-500">*</span>
                  </label>

                  <div className="flex items-center gap-6">
                    {factorySize.map((size) => (
                      <label key={size.name} className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="factory_size"
                          value={size.name}
                          checked={values?.factory_size === size.name}
                          onChange={handleChange}
                          className="form-radio text-yellowcolor focus:ring-yellowcolor"
                        />
                        <span className="ml-2 text-gray-700 text-sm dark:text-white">{size.showName}</span>
                      </label>
                    ))}
                  </div>
                  {touched.factory_size && errors.factory_size && (
                    <div className="text-red-500 text-xs mt-1">{errors.factory_size}</div>
                  )}
                </div>

                {/* Source of Raw Materials */}
                <div>
                  <label htmlFor="materials_source" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                    Source of Raw Materials<span className="text-red-500">*</span>
                  </label>

                  <div className="flex items-center gap-6">
                    {materialsSource.map((source) => (
                      <label key={source.name} className="flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          name="materials_source"
                          value={source.name}
                          checked={values?.materials_source?.includes(source.name)}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...(values?.materials_source || []), source.name]
                              : (values?.materials_source || []).filter(value => value !== source.name)
                            handleChange({
                              target: {
                                name: 'materials_source',
                                value: newValue
                              }
                            })
                          }}
                          className="form-checkbox rounded-md text-yellowcolor focus:ring-yellowcolor"
                        />
                        <span className="ml-2 text-gray-700 text-sm dark:text-white">{source.showName}</span>
                      </label>
                    ))}
                  </div>
                  {touched.materials_source && errors.materials_source && (
                    <div className="text-red-500 text-xs mt-1">{errors.materials_source}</div>
                  )}
                </div>
              </>
            )}

            {/* Password */}
            <div>
              <label htmlFor="password" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Password<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  value={values?.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Create your password"
                  className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                />
                <button
                  type="button"
                  className="absolute right-2 top-3.5 text-gray-400 hover:text-gray-700"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <FaRegEyeSlash /> : <RiEyeLine />}
                </button>
              </div>
              {touched.password && errors.password && (
                <div className="text-red-500 text-xs mt-1">{errors.password}</div>
              )}
              <div className="mt-3 space-y-1">
                {PASSWORDRULES.map((rule, idx) => {
                  const passed = rule.test(values?.password)
                  return (
                    <div key={idx} className="flex items-center text-sm">
                      <span className={`inline-flex items-center justify-center w-4 h-4 rounded-full mr-2 ${passed ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-400'}`}>{passed ? '✓' : '•'}</span>
                      <span className={passed ? 'text-green-600 font-medium' : 'text-gray-500'}>{rule.label}</span>
                    </div>
                  )
                })}
              </div>
            </div>
            {/* Confirm Password */}
            <div>
              <label htmlFor="confirmpassword" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Confirm Password<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmpassword"
                  id="confirmpassword"
                  value={values?.confirmpassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Confirm your password"
                  className="w-full font-normal bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                />
                <button
                  type="button"
                  className="absolute right-2 top-3.5 text-gray-400 hover:text-gray-700"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  tabIndex={-1}
                >
                  {showConfirmPassword ? <FaRegEyeSlash /> : <RiEyeLine />}
                </button>
              </div>
              {touched.confirmpassword && errors.confirmpassword && (
                <div className="text-red-500 text-xs mt-1">{errors.confirmpassword}</div>
              )}
            </div>
            {/* Continue Button */}
            <button
              type="submit"
              className="w-full bg-yellowcolor hover:bg-yellowcolor/90 text-black font-normal py-3 rounded-md text-base transition-colors duration-200 mb-2 shadow-none mt-2"
            >
              Continue
            </button>
            <div className="text-center font-normal text-gray-400 mt-2">
              Already have an account?{' '}
              <NavLink to="/" className="text-yellowcolor hover:underline font-medium">Login</NavLink>
            </div>
          </form>
        </div>
      </div>

      {/* Right: Image Grid */}
      <SlantedWrapper />
    </div>
    </>
  )
}

export const CombinedForm = ({
  handleBack,
  values,
  handleChange,
  handleNext,
  errors,
  touched,
  handleBlur,
  regionNames = [],
  district,
  community,
  activeStep,
  formik,
  formType,
  setFormType
}) => {
  const { countries } = useAppCountries()

  const countryOptions = countries?.map(({ name, emoji, countryCallingCode }) => ({
    label: `${emoji} ${countryCallingCode}`,
    countryLabel: name,
    value: name,
    countryCallingCode,
  }))

  const defaultCountryOption = getGhanaCountryOption()

  const [selectedCountryCode, setSelectedCountryCode] = useState(defaultCountryOption)

  useEffect(() => {
    const country = countryOptions?.find((option) => option.countryCallingCode === selectedCountryCode.countryCallingCode)
    if (country) {
      formik.setFieldValue("country", country.countryLabel)
      formik.setFieldValue("region", country.countryLabel === "Ghana" ? "Greater Accra Region" : "")
      formik.setFieldValue("district", "")
      formik.setFieldValue("community", "")
    }
  }, [selectedCountryCode])

  return (
    <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2">
      {/* Left: Registration Form */}
      <div className="max-h-[calc(100vh-40px)] overflow-y-auto flex flex-col justify-start items-center px-4 lg:mt-8 md:px-0 min-h-screen">
        <div className="w-full max-w-[380px] mx-auto flex flex-col justify-start py-8 ">
          {/* Logo and Brand */}
          <div className="flex items-center justify-center mb-6">
            <span className="inline-flex items-center gap-3">
              <SVGLogo />
              <span className="text-2xl font-bold" style={{ color: '#FDBA2F' }}>FarmerKonnect</span>
            </span>
          </div>
          <h2 className="text-3xl font-extrabold text-gray-900 mb-1 text-center dark:text-white">
            Create an account
          </h2>
          <p className="text-gray-500 text-center mb-7">Provide your details below to continue</p>
          <Stepper formType={formType} activeStep={activeStep} />
          <form className="flex flex-col gap-7">
            {/* Email */}
            <div>
              <label htmlFor="email" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Email<span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={values?.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter your email"
                className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
              />
              {touched.email && errors.email && (
                <div className="text-red-500 text-xs mt-1">{errors.email}</div>
              )}
            </div>
            {/* Phone Number */}
            <div>
              <label htmlFor="phone" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Phone Number<span className="text-red-500">*</span>
              </label>
              <div className="flex gap-2 items-center">
                <div className='w-2/4'>
                  <Select
                    options={countryOptions}
                    value={selectedCountryCode}
                    defaultValue={defaultCountryOption}
                    onChange={(option) => {
                      setSelectedCountryCode(option)
                    }}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select your country"
                    styles={{
                      control: (base) => ({
                        ...base,
                        background: "#fff",
                        borderColor: "rgba(0, 0, 0, 0.1)",
                        borderRadius: "0.5rem",
                        padding: "0.25rem",
                        "&:hover": {
                          borderColor: "#ffb733",
                        },
                        "&:focus": {
                          borderColor: "#ffb733",
                        },
                        "&:active": {
                          borderColor: "#ffb733",
                        },
                        "&:focus-within": {
                          borderColor: "#ffb733",
                        },
                        "&:focus-visible": {
                          borderColor: "#ffb733",
                        },
                        "&:outline": {
                          borderColor: "#ffb733",
                        },
                      }),
                      menu: (base) => ({
                        ...base,
                        background: "#fff",
                        border: "1px solid rgba(0, 0, 0, 0.1)",
                        borderRadius: "0.5rem",
                        marginTop: "0.5rem",
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: "#0E0202",
                        "&:hover": {
                          background: "#E2E2E2",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "#0E0202",

                      }),
                      input: (base) => ({
                        ...base,
                        color: "#0E0202",
                      }),
                    }}
                  />
                </div>

                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  value={values?.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="eg. 0540977343"
                  className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                />
              </div>
              {touched.phone && errors.phone && (
                <div className="text-red-500 text-xs mt-1">{errors.phone}</div>
              )}
            </div>
            {formType === "personal" && (
              <>
                {/* Select Gender */}
                <div>
                  <label className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                    Select Gender<span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center gap-6">

                    {gender.map((gender) => (
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="gender"
                          value={gender.value}
                          checked={values?.gender === gender.value}
                          onChange={handleChange}
                          className="form-radio text-yellowcolor focus:ring-yellowcolor"
                        />
                        <span className="ml-2 text-gray-700 text-base dark:text-white">{gender.name}</span>
                      </label>
                    ))}
                  </div>
                  {touched.gender && errors.gender && (
                    <div className="text-red-500 text-xs mt-1">{errors.gender}</div>
                  )}
                </div>

                {/* Ghana Card Number */}
                <div>
                  <label htmlFor="ghana_card_number" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                    Government-issued ID Upload (Optional)
                  </label>
                  <select
                    type="text"
                    name="id_type"
                    id="id_type"
                    value={values?.id_type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="w-full bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                  >
                    <option value="">Select card type</option>
                    <option value="ghana_card">Ghana Card</option>
                    <option value="passport">Passport</option>
                    <option value="driver_license">Driver License</option>
                    <option value="national_id">National ID</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Document Image */}
                <div>
                  {!values?.ghana_card_image && <label htmlFor="ghana_card_image"
                    className={`bg-white text-slate-500 font-semibold text-base dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-xl max-w-md h-36 flex flex-col items-center justify-center cursor-pointer mx-auto`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-11 mb-3 fill-gray-500" viewBox="0 0 32 32">
                      <path
                        d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                        data-original="#000000" />
                      <path
                        d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                        data-original="#000000" />
                    </svg>
                    <h2 className="text-base font-semibold text-yellowcolor">Click to upload</h2>

                    <input
                      type="file"
                      id='ghana_card_image'
                      name="ghana_card_image"
                      className="hidden"
                      accept="image/*"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <p className="text-xs font-medium text-slate-400 mt-2">
                      PDF, PNG or JPG (max. 5MB)
                    </p>
                  </label>}


                  {values?.ghana_card_image && <label htmlFor="ghana_card_image"
                    className={`bg-white dark:bg-secondaryDark text-slate-500 font-semibold text-base border border-yellowcolor w-full flex flex-row gap-4 rounded-xl max-w-md p-3 cursor-pointer mx-auto`}>
                    <div className="w-12 h-12 bg-yellowcolor/40 rounded-full flex items-center justify-center">
                      <div className="w-8 h-8 bg-yellowcolor/50 text-yellowcolor rounded-full flex items-center justify-center">
                        <FaRegFile />
                      </div>
                    </div>

                    <div className="w-full flex-1">
                      <div className="flex flex-row justify-between w-full">
                        <div className="flex-1">
                          <p className="flex-1 text-sm font-bold text-black dark:text-white">
                            {values?.ghana_card_image instanceof File
                              ? values.ghana_card_image.name?.slice(0, 20) + (values.ghana_card_image.name?.length > 20 ? "..." : "")
                              : values?.ghana_card_image.split("/").pop()?.slice(0, 20) + (values?.ghana_card_image.split("/").pop()?.length > 20 ? "..." : "")
                            }
                          </p>
                          <p className="text-xs font-medium text-gray-400 uppercase">
                            {values?.ghana_card_image instanceof File
                              ? values.ghana_card_image.name?.split(".").pop()
                              : values?.ghana_card_image.split("/").pop().split(".")[1]
                            }
                          </p>
                        </div>

                        <IoMdCheckmarkCircle className="text-yellowcolor" />
                      </div>

                      <div className="flex mt-4 flex-row items-center gap-2">
                        <div className="w-full h-1.5 bg-yellowcolor rounded-full"></div>
                        <p className="text-sm font-medium text-black dark:text-white">
                          100%
                        </p>
                      </div>
                    </div>

                    <input
                      type="file"
                      id='ghana_card_image'
                      name="ghana_card_image"
                      accept="image/*"
                      className="hidden"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />

                  </label>
                  }
                </div>
              </>
            )}


            {/* Country */}
            <div>
              <label htmlFor="country" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Country<span className="text-red-500">*</span>
              </label>

              <div className="relative">
                <select
                  name="country"
                  id="country"
                  value={values?.country}
                  onChange={(e) => {
                    formik.setFieldValue("country", e.target.value)
                    handleChange(e)
                    formik.setFieldValue("region", e.target.value === "Ghana" ? "Greater Accra Region" : "")
                    formik.setFieldValue("district", "")
                    formik.setFieldValue("community", "")
                  }}
                  onBlur={handleBlur}
                  className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 appearance-none focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                >
                  <option value="">Select country</option>
                  {/* {countryOptions?.map((option) => (
                    <option key={option.countryLabel} value={option.value}>
                      {option.countryLabel}
                    </option>
                  ))} */}
                  <option key="Ghana" value="Ghana">Ghana</option>
                </select>

              </div>
            </div>

            {/* Region */}
            <div>
              <label htmlFor="region" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Region<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <select
                  name="region"
                  id="region"
                  value={values?.region}
                  onChange={(e) => {
                    handleChange(e)
                    formik.setFieldValue("district", "")
                    formik.setFieldValue("community", "")
                  }}
                  onBlur={handleBlur}
                  className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 appearance-none focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                >
                  <option value="">Select region</option>
                  {regionNames.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                  <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="#A3A3A3" d="M7 10l5 5 5-5H7z" /></svg>
                </span>
              </div>
              {touched.region && errors.region && (
                <div className="text-red-500 text-xs mt-1">{errors.region}</div>
              )}
            </div>
            {/* District */}
            <div>
              <label htmlFor="district" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                District<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <select
                  name="district"
                  id="district"
                  value={values?.district}
                  onChange={(e) => {
                    handleChange(e)
                    formik.setFieldValue("community", "")
                  }}
                  onBlur={handleBlur}
                  className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 appearance-none focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                >
                  <option value="">Select district</option>
                  {district?.map((option, index) => (
                    <option key={index} value={option.name}>{option.name}</option>
                  ))}
                </select>
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                  <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="#A3A3A3" d="M7 10l5 5 5-5H7z" /></svg>
                </span>
              </div>
              {touched.district && errors.district && (
                <div className="text-red-500 text-xs mt-1">{errors.district}</div>
              )}
            </div>
            {/* Community */}
            <div>
              <label htmlFor="community" className="block text-base font-medium text-gray-700 mb-1 dark:text-white">
                Community<span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <select
                  name="community"
                  id="community"
                  value={values?.community}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="w-full bg-white dark:bg-dark border dark:border-border-dark dark:text-white rounded-md py-2 font-light px-3 appearance-none focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400"
                >
                  <option value="">Select community</option>
                  {community?.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                  <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="#A3A3A3" d="M7 10l5 5 5-5H7z" /></svg>
                </span>
              </div>
              {touched.community && errors.community && (
                <div className="text-red-500 text-xs mt-1">{errors.community}</div>
              )}
            </div>
            {/* Buttons */}
            <div className="flex flex-row gap-4 mt-2">
              <button
                type="button"
                onClick={handleBack}
                className="w-1/2 border border-yellowcolor text-yellowcolor bg-white py-3 rounded-md text-base font-normal transition-colors duration-200 dark:bg-dark"
              >
                Back
              </button>
              <button
                type="button"
                onClick={handleNext}
                className="w-1/2 bg-yellowcolor hover:bg-yellowcolor/90 text-black font-normal py-3 rounded-md text-base transition-colors duration-200 shadow-none"
              >
                Next
              </button>
            </div>
            <div className="text-center font-normal text-gray-400 mt-2">
              Already have an account?{' '}
              <NavLink to="/" className="text-yellowcolor hover:underline font-medium">Login</NavLink>
            </div>
          </form>
        </div>
      </div>
      {/* Right: Image Grid */}
      {/* <div className="sm:hidden"> */}
      <SlantedWrapper />
      {/* </div> */}
    </div>
  )
}

export const BusinessForm = ({
  handleBack,
  handleNext,
  values,
  handleChange,
  handleSubmit,
  handleBlur,
  loading,
  activeStep,
  errors,
  touched,
  formType
}) => {
  const [privacyAccepted, setPrivacyAccepted] = React.useState(false)
  const [showPolicy, setShowPolicy] = React.useState(false)
  const [showReject, setShowReject] = React.useState(false)

  const handleReject = () => {
    setShowPolicy(false)
    setShowReject(true)
  }

  return (
    <>
      {showPolicy && (
        <PrivacyModal
          onClose={() => setShowPolicy(false)}
          accept={() => setPrivacyAccepted(true)}
          handleReject={handleReject}
        />
      )}

      {showReject && (
        <PrivacyRejectedModal
          accept={() => setPrivacyAccepted(true)}
          onClose={() => setShowReject(false)}
        />
      )}

      <div className="min-h-screen w-full grid grid-cols-1 lg:grid-cols-2">
        <div className="max-h-[calc(100vh-40px)] overflow-y-auto flex flex-col justify-start items-center px-4 lg:mt-8 md:px-0 min-h-screen">
          <div className="w-full max-w-[380px] mx-auto flex flex-col justify-start py-8">
            {/* Logo and Brand */}
            <div className="flex items-center justify-center mb-6">
              <span className="inline-flex items-center gap-3">
                <SVGLogo />
                <span className="text-2xl font-bold" style={{ color: '#FDBA2F' }}>
                  FarmerKonnect
                </span>
              </span>
            </div>
            {/* Rest of BusinessForm content */}
            <h2 className="text-3xl font-extrabold text-gray-900 mb-1 text-center dark:text-white">
              Create an account
            </h2>
            <p className="text-gray-500 text-center mb-2">Provide your details below to continue</p>
            <p className="text-black text-center mb-7 dark:text-white">
              You're almost done — just one final step!
            </p>
            <Stepper formType={formType} activeStep={activeStep} />
            <form className="flex flex-col gap-7" onSubmit={handleSubmit}>


              {/* Document Image */}
              <div>
                <label htmlFor="ghana_card_number" className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
                  Upload your business registration document to accelerate your verification (optional)
                </label>

                {!values?.doc_url && <label htmlFor="doc_url"
                  className={` text-slate-500 font-semibold text-base bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-xl max-w-md h-36 flex flex-col items-center justify-center cursor-pointer mx-auto`}>
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-11 mb-3 fill-gray-500" viewBox="0 0 32 32">
                    <path
                      d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                      data-original="#000000" />
                    <path
                      d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                      data-original="#000000" />
                  </svg>
                  <h2 className="text-base font-semibold text-yellowcolor">Click to upload</h2>

                  <input
                    type="file"
                    id='doc_url'
                    name="doc_url"
                    // accept="application/pdf"
                    className="hidden"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <p className="text-xs font-medium text-slate-400 mt-2">
                    PDF, PNG or JPG (max. 5MB)
                  </p>
                </label>}


                {values?.doc_url && <label htmlFor="doc_url"
                  className={`bg-white dark:bg-secondaryDark text-slate-500 font-semibold text-base border border-yellowcolor w-full flex flex-row gap-4 rounded-xl max-w-md p-3 cursor-pointer mx-auto`}>
                  <div className="w-12 h-12 bg-yellowcolor/40 rounded-full flex items-center justify-center">
                    <div className="w-8 h-8 bg-yellowcolor/50 text-yellowcolor rounded-full flex items-center justify-center">
                      <FaRegFile />
                    </div>
                  </div>

                  <div className="w-full flex-1">
                    <div className="flex flex-row justify-between w-full">
                      <div className="flex-1">
                        <p className="text-sm font-bold text-black dark:text-white">
                          {values?.doc_url instanceof File
                            ? values.doc_url.name
                            : values?.doc_url.split("/").pop()
                          }
                        </p>
                        <p className="text-xs font-medium text-gray-400 uppercase">
                          {values?.doc_url instanceof File
                            ? values.doc_url.name?.split(".").pop()
                            : values?.doc_url.split("/").pop().split(".")[1]
                          }
                        </p>
                      </div>

                      <IoMdCheckmarkCircle className="text-yellowcolor" />
                    </div>

                    <div className="flex mt-4 flex-row items-center gap-2">
                      <div className="w-full h-1.5 bg-yellowcolor rounded-full"></div>
                      <p className="text-sm font-medium text-black dark:text-white">
                        100%
                      </p>
                    </div>
                  </div>

                  <input
                    type="file"
                    id='doc_url'
                    name="doc_url"
                    // accept="application/pdf"
                    className="hidden"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />

                </label>
                }

                {touched.doc_url && errors.doc_url && (
                  <div className="text-red-500 text-xs mt-1">{errors.doc_url}</div>
                )}
              </div>

              <div>
                <div className="flex flex-row gap-3">
                  <button
                    type="button"
                    onClick={() => setShowPolicy(true)}
                    className={`outline-none w-6 h-6 border ${privacyAccepted ? "border-yellowcolor" : "border-gray-200"} rounded-md flex items-center justify-center`}>
                    {privacyAccepted && <IoMdCheckmark className="text-yellowcolor text-lg" />}
                  </button>

                  <div className="flex-1">
                    <p className="text-sm font-medium text-black dark:text-white">
                      Privacy Acceptance
                    </p>
                    <p className="text-sm font-medium text-gray-400">
                      By continuing, you agree to our <a href="#" className="underline text-black dark:text-white">Terms & conditions</a> and our <a href="#" className="underline text-black dark:text-white">Privacy policy</a>.
                    </p>
                  </div>


                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-row gap-4 mt-2">
                <button
                  type="button"
                  onClick={handleBack}
                  disabled={loading}
                  className="w-1/2 border border-yellowcolor text-yellowcolor bg-white py-3 rounded-md text-base font-normal transition-colors duration-200 dark:bg-dark"
                >
                  Back
                </button>
                <button
                  type="submit"
                  className={`w-1/2 ${privacyAccepted ? "bg-yellowcolor hover:bg-yellowcolor/90 text-black" : "bg-gray-300 text-gray-500"
                    } font-normal py-3 rounded-md text-base transition-colors duration-200 shadow-none`}
                  disabled={!privacyAccepted}
                >
                  {loading ? "Please wait..." : "Done"}
                </button>
              </div>
              <div className="text-center font-normal text-gray-400 mt-2">
                Already have an account?{' '}
                <NavLink to="/" className="text-yellowcolor hover:underline font-medium">Login</NavLink>
              </div>
            </form>
          </div>
        </div>
        {/* Right: Image Grid */}
        {/* <div className="sm:hidden"> */}
        <SlantedWrapper />
        {/* </div> */}
      </div>
    </>
  )
}